import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

export default function Footer() {
  return (
    <div className="bg-[#00476C] pt-8">
      <footer className="relative border-b-2 mx-auto w-full max-w-8xl border-gray-200">
        <div className="container mx-auto px-6">
          <div className="w-full grid lg:grid-cols-4 md:grid-cols-2 text-white">
            <div className="flex flex-col mb-6 min-w-max mr-2 col-span-1">
              <span className="font-bold text-2xl text-[#e8a552]">
                Quick Links
              </span>
              <div className="md:pl-4 pl-0 flex flex-col">
                <span className="mt-4">
                  <span className="mr-1">{`>`}</span>
                  <a
                    href="https://www.reinsw.com.au/"
                    target="_blank"
                    rel="noreferrer"
                    className=" text-xs hover:text-gray-300 underline"
                  >
                    REINSW Home
                  </a>
                </span>
                <span>
                  <span className="mr-1">{`>`}</span>
                  <a
                    href="https://www.reiformslive.com.au/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs hover:text-gray-300 underline"
                  >
                    REI Forms Live
                  </a>
                </span>
                <span>
                  <span className="mr-1">{`>`}</span>
                  <Link
                    className="text-xs hover:text-gray-300 underline"
                    to="/guide"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Guide
                  </Link>
                </span>
                <span>
                  <span className="mr-1">{`>`}</span>
                  <Link
                    className="text-xs hover:text-gray-300 underline"
                    to="/faq"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FAQ's
                  </Link>
                </span>
              </div>
            </div>

            <div className="flex flex-col mr-2 col-span-1">
              <span className="font-bold text-2xl text-[#e8a552] sm:mt-0 mb-2">
                Legal
              </span>
              <span className="underline mt-4">
                <a
                  href="https://www.reinsw.com.au/Web/Content/Privacy_policies/website-terms.aspx"
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs hover:text-gray-300"
                >
                  Terms of use
                </a>
              </span>
              <span className="underline">
                <a
                  href="https://www.reinsw.com.au/Privacy"
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs hover:text-gray-300"
                >
                  Privacy policy
                </a>
              </span>
              <span className="mt-4 text-sm">ABN 51 000 012 457</span>
              <span className="mt-4 text-sm">
                This website provides information of a general nature about
                REINSW, its products and services, and real estate practice in
                NSW. REINSW offers training subsidised by the NSW Government:
              </span>
              <span className="underline">
                <a
                  href="https://education.nsw.gov.au/skills-nsw"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  www.smartandskilled.nsw.gov.au
                </a>
              </span>
              <span className="my-4 text-sm">
                Real Estate Institute of New South Wales - RTO Number: 90117
                (Registered Training Organisation)
              </span>
            </div>

            <div className="flex flex-col mr-2 min-w-max col-span-1">
              <span className="font-bold text-2xl text-[#e8a552] mt-4 sm:mt-0 mb-2">
                Connect with us
              </span>
              <span className="mt-4">
                <a
                  href="tel:0292642343"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  (02) 9264 2343
                </a>
              </span>
              <span className="mt-4 text-xs">
                <a
                  href="mailto:info@reinsw.com.au"
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs hover:text-gray-300 underline"
                >
                  info@reinsw.com.au
                </a>
              </span>

              {/* social links */}
              <div className="mt-4 flex space-x-2">
                <a
                  href="https://www.facebook.com/REINSW"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  <FaFacebookF className="text-2xl" />
                </a>
                <a
                  href="https://twitter.com/REINSWnews"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  <FaTwitter className="text-2xl" />
                </a>
                <a
                  href="https://www.linkedin.com/company/rei-nsw/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  <FaLinkedinIn className="text-2xl" />
                </a>
                <a
                  href="https://www.youtube.com/user/REINSW"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  <FaYoutube className="text-2xl" />
                </a>
                <a
                  href="https://www.instagram.com/reinsw_au/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-gray-300"
                >
                  <FaInstagram className="text-2xl" />
                </a>
              </div>

              <span className="mt-2 text-sm">We would love your feedback.</span>
              <span className="-mt-1">
                <a
                  href="https://g.page/reinsw/review?mt"
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs underline"
                >
                  Post a review to our Google profile
                </a>
              </span>
            </div>

            <div className="flex flex-col col-span-1">
              <span className="font-bold text-2xl text-[#e8a552] mt-4 sm:mt-0 mb-2">
                Subscribe
              </span>
              <div className="w-72 text-sm mt-4">
                <span className="mt-4 font-bold text-sm">Not a member? </span>
                <a
                  className="underline text-xs"
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.reinsw.com.au/Web/Join/Non_Members/Create_Account.aspx"
                >
                  Create a website account
                </a>
                <span>
                  {" "}
                  to receive industry news plus event and special offer updates
                  and more.
                </span>
                <div className="mt-4">
                  If you are a member sign in to update your communication
                  preferences to ensure you don't miss an update.
                </div>
                <a
                  href="https://www.reinsw.com.au/Web/Join/Non_Members/Create_Account.aspx"
                  className="bg-[#E8A552] py-1.5 text-lg mt-4 font-semibold px-6 text-center block w-3/4 mb-6 hover:underline"
                >
                  Create Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );

}
